import { useEffect } from "react";
import { scrollWindowToTop } from "helpers";

const ScrollToTop = ({ children, location: { pathname } }) => {
	useEffect(() => scrollWindowToTop(), [pathname]);
	return children;
};

export default ScrollToTop;